const isTripClosed = (trip) => !!trip?.verified || !!trip?.lockState?.locked;

export const isTripLockedForUser = (trip, superAdmin, verificationAdmin) =>
  isTripClosed(trip) && !superAdmin && !verificationAdmin;

export const isTripClosedForUser = ({ verified, locked, superAdmin, verificationAdmin }) =>
  (!!verified || !!locked) && !superAdmin && !verificationAdmin;
